import { Component, ElementRef, ViewChild } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  List,
  Content,
  ActionSheetController
} from "ionic-angular";
import { ChatInfoPage } from "../chat-info/chat-info";
import { ChatProvider } from "../../providers/chat/chat.provider";
import { UserProvider } from "../../providers/user/user.provider";
import { EventPage } from "../event/event";
import { map } from "rxjs/operators";
/**
 * Generated class for the ChatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-chat",
  templateUrl: "chat.html"
})
export class ChatPage {
  chat_input: string = "";
  event: any;
  user: any;
  chat: any;
  messages: any;
  users: any = [];
  deltaY: any = 0;
  fromChat: Boolean = false;
  initialized: Boolean = false;
  user_list = [];
  showButtonScroll = false;

  private mutationObserver: MutationObserver;
  @ViewChild(Content) contentArea: Content;
  @ViewChild(List, { read: ElementRef }) messagesList: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private chatProvider: ChatProvider,
    private actionSheetCtrl: ActionSheetController,
    private userProvider: UserProvider
  ) {
    this.event = this.navParams.get("event");
    this.fromChat = this.navParams.get("fromChat");
  }

  ngAfterViewInit() {
    this.contentArea.ionScroll.subscribe(data => {
      //... do things
      // console.log("data",data);
      this.deltaY = data && data.deltaY ? data.deltaY : 0;
      if (this.deltaY && this.deltaY > -100) this.showButtonScroll = false;
    });
  }
  ionViewDidLoad() {
    this.mutationObserver = new MutationObserver(mutations => {
      // console.log("LIST UPDATED");
      // console.log("this.contentArea.deltaY", this.deltaY);
      // console.log("this.contentArea.scrollTop", this.scrollTop);
      // console.log("this.contentArea.scrollHeight", this.scrollHeight);
      if (!this.initialized || this.deltaY > -100) {
        this.initialized = true;
        this.scrollToBottom();
      } else {
        // console.log("show new message");
        this.showButtonScroll = true;
      }

      this.loadUsers();
    });

    this.mutationObserver.observe(this.messagesList.nativeElement, {
      childList: true
    });
  }

  scrollToBottom() {
    // console.log("scrollToBottom");
    this.contentArea.scrollToBottom();
    this.showButtonScroll = false;
  }

  ionViewDidEnter() {
    // console.log('ionViewDidLoad ChatPage');
    // console.log("this.event", this.event);
    this.refresh();
  }
  goChatInfo() {
    // console.log("goChatInfo");
    this.navCtrl.push(ChatInfoPage, { users: this.users });
  }

  goEvent() {
    if (this.fromChat) this.navCtrl.push(EventPage, { event: this.event });
    else this.navCtrl.pop();
  }

  async refresh() {
    // let messages = await this.chatProvider.getLiveChat(this.event.id);
    if (this.user == null) this.user = await this.userProvider.getUser();
    await this.loadMessages();
    // console.log("user_list", this.user_list);
    // console.log("this.user", this.user);
    // console.log("this.messages", this.messages);
  }

  async loadMessages(){
    let ref = await this.chatProvider.getChatSnapshot(this.event.id);
    this.messages = ref.pipe(
      map(actions =>
        actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          if (this.user_list.indexOf(data.user_id) == -1) {
            this.user_list.push(data.user_id);
          }
          return { id, ...data };
        })
      )
    );
  }

  async loadUsers() {
    for (let user of this.user_list) {
      // console.log("loadUsers user", user);
      if (!this.users[user]) {
        this.users[user] = await this.userProvider.getUser(user);
        // console.log("result",result);
      }
    }
    // console.log("this.users", this.users);
  }

  async sendMessage() {
    await this.chatProvider.sendMessage(
      this.event.id,
      this.user.uid,
      this.chat_input
    );
    this.chat_input = "";
  }

  presentActionSheet(message) {
    let actionSheet = this.actionSheetCtrl.create({
      title: message.text,
      buttons: [
        {
          text: "Signaler",
          role: "destructive",
          handler: () => {
            console.log("Destructive clicked");
          }
        },
        {
          text: "Modifier",
          handler: () => {
            console.log("Archive clicked");
          }
        },
        {
          text: "Annuler",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        }
      ]
    });

    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/chat/chat.ts